import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import { PHONE_TOOL_URL } from "../avatar/avatarConstants";
import { styledWithTheme } from "../context";
import { Link } from "../link";
import { Text } from "../text";
import { getUniqueId } from "../utils";
import { AVATAR_USERNAME_LINK_INVERTED_COLOR, AVATAR_USERNAME_LINK_DEFAULT_COLOR, AVATAR_USERNAME_TEXT_DEFAULT_COLOR, AVATAR_USERNAME_TEXT_INVERTED_COLOR } from "./constants";
import { ChipColorScheme } from "./interfaces";
import { jsx as ___EmotionJSX } from "@emotion/core";
var StyledUsername = styledWithTheme(Text)(function (_ref) {
  var theme = _ref.theme,
      color = _ref.color;
  return {
    color: theme.selectors.color(color || AVATAR_USERNAME_TEXT_DEFAULT_COLOR)
  };
});
var StyledLink = styledWithTheme(Link)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    fontWeight: theme.selectors.fontWeight('regular'),
    ':hover': {
      textDecoration: 'underline'
    }
  };
});

var onClick = function onClick(e) {
  // Prevent the event from bubbling, which stops issues
  // such as onRowClick being fired when clicking the link
  // in tables.
  e.stopPropagation();
};

var ChipAvatarLink = function ChipAvatarLink(_ref3) {
  var username = _ref3.username,
      fontSize = _ref3.fontSize,
      newTabHiddenText = _ref3.newTabHiddenText,
      colorScheme = _ref3.colorScheme,
      _ref3$isClickable = _ref3.isClickable,
      isClickable = _ref3$isClickable === void 0 ? true : _ref3$isClickable;
  var linkCssValues = {
    color: colorScheme === ChipColorScheme.DarkBackground ? AVATAR_USERNAME_LINK_INVERTED_COLOR : AVATAR_USERNAME_LINK_DEFAULT_COLOR,
    fontSize: fontSize,
    textDecoration: colorScheme === ChipColorScheme.DarkBackground ? 'underline' : 'none'
  };

  var accessibleUsername = ___EmotionJSX(React.Fragment, null, username, ___EmotionJSX("span", {
    "aria-hidden": "true"
  }, '@'));

  var newTabHiddenTextId = useMemo(function () {
    return "new-tab-hidden-text-".concat(getUniqueId(), "-id");
  }, []);

  if (!isClickable) {
    return ___EmotionJSX(StyledUsername, {
      fontSize: fontSize,
      color: colorScheme === ChipColorScheme.DarkBackground ? AVATAR_USERNAME_TEXT_INVERTED_COLOR : AVATAR_USERNAME_TEXT_DEFAULT_COLOR
    }, accessibleUsername);
  }

  return ___EmotionJSX(StyledLink, _extends({}, linkCssValues, {
    href: "".concat(PHONE_TOOL_URL).concat(username),
    onClick: onClick,
    target: "_blank",
    "aria-describedby": newTabHiddenTextId
  }), accessibleUsername, ___EmotionJSX("span", {
    hidden: true,
    id: newTabHiddenTextId
  }, newTabHiddenText));
};

export default ChipAvatarLink;